import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { DataProvider } from "./components/DataContext.js";
import Home from "./components/Home.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

/* ReactDOM.render(
 *     <React.StrictMode>
 *  	<DataProvider>
 *  	    <Home/>
 *  	</DataProvider>
 *     </React.StrictMode>,
 *     document.getElementById("root")
 * );
 *  */
root.render(
    <React.StrictMode>
  	<DataProvider>
  	    <Home/>
  	</DataProvider>
    </React.StrictMode>
);

